// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {buildPayload} from '../services/build-payload';
import {getDealerInvoices} from '../../shared/repositories';
import {getSelectedDisplayedDealers} from '../../../shared/services/facets';

export const readDealerInvoices = isInitialLoad =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const facets = getState().claims.dealerInvoices.facets;

        const accounts = isInitialLoad ?
            facets.dealerAccountsFacet.allowedDealers :
            getSelectedDisplayedDealers(facets.dealerAccountsFacet);

        const payload = buildPayload(accounts, '', '');

        try {

            const dealerInvoices = await getDealerInvoices(payload);

            dispatch({
                data: dealerInvoices,
                type: actions.SET_DEALER_INVOICE_LIST
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/action-creators/read-dealer-invoices.js